import { render } from "./ExternalSystemsAddMicrosoftAzure.vue?vue&type=template&id=4dc5d366&scoped=true&ts=true"
import script from "./ExternalSystemsAddMicrosoftAzure.vue?vue&type=script&lang=ts"
export * from "./ExternalSystemsAddMicrosoftAzure.vue?vue&type=script&lang=ts"

import "./ExternalSystemsAddMicrosoftAzure.vue?vue&type=style&index=0&id=4dc5d366&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc5d366"]])

export default __exports__